<div class="wrapper" ngbTooltip="{{ 'User settings' | translate }}">
  <a (click)="overlay.toggle($event)">
    <svg class="svg-inline--fa fa-w-20">
      <use xlink:href="#user"></use>
    </svg>
  </a>
</div>
<qm-overlay-panel #overlay [stickTo]="'left-bottom'" [appendTo]="'body'" [dismissable]="true">
  <div class="card" style="margin-top: 0.8em;">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</qm-overlay-panel>
<ng-template #content>
  <div class="d-flex flex-column list">
    <div class="list-block" *qmAuth="'superuser'">
        <button type="button" class="custom-button" (click)="navigateToSuperuser()">
          <span>
            <i class="fas fa-user-shield"></i>
          </span>
          <!-- TODO: better name, add translation?-->
          <span class="label">Superuser</span>
        </button>
      </div>
    <div class="list-block">
      <button type="button" class="custom-button" (click)="changeLanguage()">
          <span>
            <svg class="svg-inline--fa fa-w-20">
              <use xlink:href="#language"></use>
            </svg>
          </span>
        <span class="label">{{'Language' | translate}}: {{settings.language.toUpperCase()}}</span>
      </button>
    </div>
    <div class="list-block">
      <button type="button" class="custom-button" (click)="resetState()">
          <span>
            <svg class="svg-inline--fa fa-w-20">
              <use xlink:href="#redo"></use>
            </svg>
          </span>
        <span class="label">{{'Reset settings' | translate}}</span>
      </button>
    </div>
    <div class="list-block">
      <button type="button" class="custom-button" (click)="logOutUser()">
            <span>
              <svg class="svg-inline--fa fa-w-20">
                <use xlink:href="#logout"></use>
              </svg>
            </span>
        <span class="label">{{'Log out' | translate}}</span>
      </button>
    </div>
    <div class="list-block">
      <p class="version-button">
        {{'Application version' | translate}}:
        <br/>
        {{version}}
      </p>
    </div>
  </div>
</ng-template>

<i class="fas fa-user" data-fa-symbol="user"></i>
<i class="far fa-language" data-fa-symbol="language"></i>
<i class="far fa-redo" data-fa-symbol="redo"></i>
<i class="far fa-sign-out" data-fa-symbol="logout"></i>
